import { useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SwipeNavigator({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  const pages = [
    '/',
    '/ask',
    '/resume',
    '/account',
    ...((['admin', 'superadmin'].includes(user?.role)) ? ['/admin'] : []),
  ];

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = e.changedTouches[0].clientY - touchStartY.current;
    touchStartX.current = null;

    // Ignore if mostly vertical or too short
    if (Math.abs(dx) < Math.abs(dy) || Math.abs(dx) < 60) return;

    const idx = pages.indexOf(location.pathname);
    if (idx === -1) return;

    if (dx < 0 && idx < pages.length - 1) {
      navigate(pages[idx + 1]);
    } else if (dx > 0 && idx > 0) {
      navigate(pages[idx - 1]);
    }
  };

  return (
    <div
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      style={{ minHeight: 'calc(100vh - 64px)' }}
    >
      {children}
    </div>
  );
}
